module.exports = __webpack_public_path__ + "img/66-l.5215860a.png";